import './webinar-plus-backdrop.scss';
import WebinarPlusFrame from '@/themes/webinar-plus/webinar-plus-backdrop/webinar-plus-frame/webinar-plus-frame';
import { FilePaths, getImagePath } from '@ui/utils/static-images.client';

const WebinarPlusBackdrop = () => {
  return (
    <>
      <img
        className="webinar-plus-backdrop"
        src={getImagePath(FilePaths.WebinarPlusBackdrop)}
        alt="webinar plus backdrop"
      />
      <WebinarPlusFrame />
    </>
  );
};

export default WebinarPlusBackdrop;
